import React from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import bgg from "assets/img/bgg.png";
import headofschool from "assets/img/headofschool.png";
import facilitators from "assets/img/facilitators.png";
import admissionmanager from "assets/img/admissionmanager.png";
import operationalmanager from "assets/img/operationalmanager.png";

export default function HowToApply() {
  return (
    <>
      <AdminNavbar fixed />
      <section className="">
        <div
          className=" xl:pt-32 xl:pb-16 lg:pt-32 lg:pb-16 md:pt-28 md:pb-16 pt-32 pb-16"
          style={{
            backgroundColor: "#f0f7fa",
            backgroundImage: `url(${bgg})`,
            backgroundPosition: "center center", // Correct property name
            backgroundRepeat: "repeat", // No need to quote unless special characters
            backgroundSize: "55% auto", // No dash in property names
          }}
        >
          <div className="container mx-auto">
            <div className=" ">
              {/* <p className="text-peach xl:text-3xl lg:text-3xl md:text-2xl text-xl bubblegum">
                Career
              </p> */}
              <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl pt-2 font-bold text-black pt-2 text-center">
                JOIN THE CARING CREW
              </h2>
              <p
                className="xl:text-xl xl:mt-3 mt-2 text-center xl:px-32 lg:px-32 "
                style={{ lineHeight: 1.9 }}
              >
                At Junior Toes, we believe in building a team that embodies our
                philosophy of nurturing creativity, leadership, and holistic
                growth in young learners. We are looking for passionate,
                dedicated, and innovative professionals to join us in shaping
                the future of early childhood education.
              </p>
            </div>
          </div>
        </div>

        <div className="container mx-auto xl:mt-16 lg:mt-16 mt-12 ">
          <h2 className="text-black font-semibold xl:text-3xl lg:text-3xl md:text-2xl text-2xl text-center">
            Career Opportunities
          </h2>

         
        </div>
      </section>

      {/* new section */}
      <section className="xl:py-16 lg:py-16 md:py-12 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 xl:block lg:block md:block sm:hidden hidden ">
        <div className="flex gap-6">
          <div className="xl:w-12/12 lg:w-12/12 md:w-12/12 h-full w-full">
            <div className="flex items-center ">
              <div
                className="xl:w-10/12 lg:w-10/12 md:w-12/12 md:py-10 md:px-4 lg:py-10 lg:px-6 xl:py-10 xl:px-8 rounded"
                style={{ border: "1px solid #d1dbde" }}
              >
                <h1 className="text-black xl:text-2xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Head of School
                </h1>
                <h6 className="text-blue font-semibold xl:text-base text-base pt-1 xl:pt-1">
                  Role
                </h6>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12 xl:w-11/12 md:w-11/12 ">
                  The Head of School will be responsible for overseeing the
                  entire academic and administrative operations of Junior Toes,
                  ensuring that the school’s philosophy, curriculum, and daily
                  functioning meet the highest standards.
                </p>
                <button className="items-center border-0 focus:outline-none  text-xs text-peach xl:text-xs uppercase underline xl:pt-4 lg:pt-4">
                  <a href="/head-of-school">
                    Apply Now{" "}
                    <i className="las la-angle-double-right text-peach"></i>
                  </a>
                </button>
              </div>
              <div
                className="  xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded  xl:-ml-12 lg:-ml-8 md:-ml-8"
                // style={{ border: "1px solid #ccc" }}
              >
                <img className="" src={headofschool} alt="" />
              </div>
            </div>
          </div>

          <div className="xl:w-12/12 lg:w-12/12 md:w-12/12 h-full w-full xl:mb-4 lg:mb-6 md:mb-4">
            <div className="flex items-center ">
              <div
                className=" xl:w-10/12 lg:w-10/12 md:w-12/12 lg:py-10 lg:px-6 xl:py-8 xl:px-8  md:px-4 md:py-10 rounded"
                style={{ border: "1px solid #d1dbde" }}
              >
                <h1 className="text-black xl:text-2xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Pre-Primary Facilitators(Teachers)
                </h1>
                <h6 className="text-blue font-semibold xl:text-base text-base pt-1 xl:pt-1">
                  Role
                </h6>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12  xl:w-11/12 md:w-10/12 ">
                  As a Pre-Primary Facilitator at Junior Toes, you will create
                  and deliver engaging learning experiences that foster critical
                  thinking, creativity, and socialemotional growth in
                  preschoolers.
                </p>
                <button className="items-center border-0 focus:outline-none text-peach xl:text-xs uppercase underline text-xs xl:pb-2 lg:pb-0 xl:pt-4 lg:pt-4">
                  <a href="/pre-primary-facilitators">
                    Apply Now{" "}
                    <i className="las la-angle-double-right text-peach"></i>
                  </a>
                </button>
              </div>
              <div
                className=" xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded   xl:-ml-12 lg:-ml-8 md:-ml-16"
                // style={{ border: "1px solid #ccc" }}
              >
                <img className="" src={facilitators} alt="" />
              </div>
            </div>
          </div>
        </div>
        {/* three and four */}

        <div className="flex gap-6 xl:mt-4 lg:mt-2">
          <div className="xl:w-12/12 lg:w-12/12 md:w-12/12 h-full w-full">
            <div className="flex items-center  ">
              <div
                className=" xl:w-10/12 lg:w-10/12 md:w-12/12 md:py-10 md:px-4 lg:py-10 lg:px-6 xl:py-10 xl:px-8 rounded"
                style={{ border: "1px solid #d1dbde" }}
              >
                <h1 className="text-black xl:text-2xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Admission Manager
                </h1>
                <h6 className="text-blue font-semibold xl:text-base text-base pt-1 xl:pt-1">
                  Role
                </h6>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12 xl:w-11/12 md:w-11/12">
                  The Admission Manager will oversee the student admission
                  process, guiding parents through inquiries, applications, and
                  enrollment, ensuring a smooth and welcoming experience for new
                  families.
                </p>
                <button className="items-center border-0 focus:outline-none  text-peach xl:text-xs uppercase underline text-xs xl:mt-4 lg:mt-4">
                  <a href="/admission-manager">
                    Apply Now{" "}
                    <i className="las la-angle-double-right text-peach"></i>
                  </a>
                </button>
              </div>
              <div
                className="xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded  xl:-ml-12 lg:-ml-8 md:-ml-8"
                // style={{ border: "1px solid #ccc" }}
              >
                <img className="" src={operationalmanager} alt="" />
              </div>
            </div>
          </div>

          <div className="xl:w-12/12 lg:w-12/12 md:w-12/12 h-full w-full">
            <div className="flex items-center ">
              <div
                className="xl:w-10/12 lg:w-10/12 md:w-12/12 lg:py-12 lg:px-6 xl:py-10 xl:px-8  md:px-4 md:py-16 rounded"
                style={{ border: "1px solid #d1dbde" }}
              >
                <h1 className="text-black xl:text-2xl lg:text-2xl md:text-2xl md:pt-2 lg:pt-2 font-semibold xl:pt-3">
                  Operational Manager
                </h1>
                <h6 className="text-blue font-semibold xl:text-base text-base pt-1 xl:pt-1">
                  Role
                </h6>
                <p className="xl:pt-4 lg:pt-4 lg:w-11/12 lg:pb-4 xl:w-11/12 md:w-10/12 md:pb-0 xl:pb-6">
                  The Operational Manager will ensure the smooth and efficient
                  running of all school operations, including facility
                  management, logistics, and administrative functions.
                </p>
                <button className="items-center border-0 focus:outline-none xl:mt-3 text-peach xl:text-xs uppercase underline text-xs lg:mt-0 ">
                  <a href="/operation-manager">
                    Apply Now{" "}
                    <i className="las la-angle-double-right text-peach"></i>
                  </a>
                </button>
              </div>
              <div
                className=" xl:w-5/12 lg:w-5/12 md:w-5/12 bg-white rounded   xl:-ml-12 lg:-ml-8 md:-ml-18"
                // style={{ border: "1px solid #ccc" }}
              >
                <img className="" src={admissionmanager} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mobile view */}
      <section className="xl:hidden lg:hidden md:hidden sm:block block pb-12 px-4">
        <div className=" h-full w-full ">
          <div className="">
            <div
              className=" py-20 px-4 rounded"
              style={{ border: "1px solid #d1dbde" }}
            >
              <h1 className="text-black text-2xl pt-2 font-semibold">
                Head of School
              </h1>
              <h6 className="text-blue font-semibold  text-base pt-1 ">Role</h6>
              <p className="pt-4  ">
                The Head of School will be responsible for overseeing the entire
                academic and administrative operations of Junior Toes, ensuring
                that the school’s philosophy, curriculum, and daily functioning
                meet the highest standards.
              </p>
              <button className="items-center border-0 focus:outline-none  text-xs text-peach uppercase underline">
                <a href="/head-of-school">
                  Apply Now{" "}
                  <i className="las la-angle-double-right text-peach"></i>
                </a>
              </button>
            </div>
            <div
              className="  rounded flex justify-center "
              
            >
              <img className="w-8/12 -mt-12" src={headofschool} alt="" />
            </div>
          </div>
        </div>

        <div className=" mt-12 h-full w-full ">
          <div className=" ">
            <div
              className=" py-20 px-4 rounded"
              style={{ border: "1px solid #d1dbde" }}
            >
              <h1 className="text-black text-2xl pt-2 font-semibold">
                Pre-Primary Facilitators <br></br>(Teachers)
              </h1>
              <h6 className="text-blue font-semibold  text-base pt-1 ">Role</h6>
              <p className="pt-4  ">
                As a Pre-Primary Facilitator at Junior Toes, you will create and
                deliver engaging learning experiences that foster critical
                thinking, creativity, and socialemotional growth in
                preschoolers.
              </p>
              <button className="items-center border-0 focus:outline-none  text-xs text-peach uppercase underline">
                <a href="/pre-primary-facilitators">
                  Apply Now{" "}
                  <i className="las la-angle-double-right text-peach"></i>
                </a>
              </button>
            </div>
            <div
              className=" flex justify-center rounded "
              
            >
              <img className="w-8/12 -mt-12" src={facilitators} alt="" />
            </div>
          </div>
        </div>

        <div className=" mt-12 h-full w-full">
          <div className=" ">
            <div
              className=" py-20 px-4 rounded"
              style={{ border: "1px solid #d1dbde" }}
            >
              <h1 className="text-black text-2xl pt-2 font-semibold">
                Admission Manager
              </h1>
              <h6 className="text-blue font-semibold  text-base pt-1 ">Role</h6>
              <p className="pt-4  ">
                The Admission Manager will oversee the student admission
                process, guiding parents through inquiries, applications, and
                enrollment, ensuring a smooth and welcoming experience for new
                families.
              </p>
              <button className="items-center border-0 focus:outline-none  text-xs text-peach uppercase underline">
                <a href="/admission-manager">
                  Apply Now{" "}
                  <i className="las la-angle-double-right text-peach"></i>
                </a>
              </button>
            </div>
            <div
              className=" flex justify-center rounded "
              // style={{ border: "1px solid #ccc" }}
            >
              <img className="w-8/12 -mt-12" src={operationalmanager} alt="" />
            </div>
          </div>
        </div>

        <div className=" mt-12 h-full w-full ">
          <div className=" ">
            <div
              className=" py-20 px-4 rounded"
              style={{ border: "1px solid #d1dbde" }}
            >
              <h1 className="text-black text-2xl pt-2 font-semibold">
                Operational Manager
              </h1>
              <h6 className="text-blue font-semibold  text-base pt-1 ">Role</h6>
              <p className="pt-4  ">
                The Operational Manager will ensure the smooth and efficient
                running of all school operations, including facility management,
                logistics, and administrative functions.
              </p>
              <button className="items-center border-0 focus:outline-none xl:mt-3 text-peach xl:text-xs uppercase underline text-xs lg:mt-0 ">
                <a href="/operation-manager">
                  Apply Now{" "}
                  <i className="las la-angle-double-right text-peach"></i>
                </a>
              </button>
            </div>
            <div
              className=" rounded flex justify-center"
              // style={{ border: "1px solid #ccc" }}
            >
              <img className="w-8/12 -mt-12" src={admissionmanager} alt="" />
            </div>
          </div>
        </div>
      </section>
      <Footer2 />
    </>
  );
}
